export const GET_SINGLE_BANNER_ITEM = "GET_SINGLE_BANNER_ITEM";
export const GET_SINGLE_SLIDER_ITEM = "GET_SINGLE_SLIDER_ITEM";
